import { Box, styled } from '@mui/material';

export const StyledNote = styled(Box)(() => ({
  width: '100%',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '10px',
  lineHeight: '12px',
  color: '#37474F',
  display: 'flex',
}));

export const StyledAsterisk = styled(Box)(() => ({
  color: '#C44D56',
}));
